<template>
    <div class="w-100">
        <div class="w-100 px-3 py-2 bg-white shadow-sm rounded" v-on:click="toggleActive" style="cursor: pointer;user-select:none;">
             <input type="text" class="w-100 rounded p-1 form-control" v-if="direct" :placeholder="placeholder" v-model="searchValue" v-on:input="valueChanged">
            {{!direct?getLabelText:''}}<span class="btn-exit float-right" @click.stop.prevent="clear()" v-show="hasValue && !direct">X</span>
            <hr class="m-0 p-0"/>
        </div>
        
        <div class="w-100" style="position:relative">
            <div class="w-100 px-3 py-3 bg-white shadow-sm rounded mt-2" v-if="isFocus||fetching" style="position:absolute;top:0;z-index:800">
                <input type="text" v-if="!direct" class="w-100 rounded p-1" :placeholder="placeholder" v-model="searchValue" v-on:input="valueChanged">
                <div class="w-100 py-1" v-if="(fetching || nextQueue) && (init || searchValue!='')">
                    <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Mencari data</strong>
                    </div>
                </div>
                <div class="w-100 mt-1 border border-light rounded" style="overflow-y:scroll;top:0;max-height:250px" v-if="!fetching && !nextQueue && (searchValue!='' || init)">
                    
                    <span v-for="opt in options" v-bind:key="name+'smrtsrc'+opt+key" class="px-1 py-2 selection rounded d-block" v-show="opt[keyTag]!=''" v-on:click="dataUpdate(opt)">{{getLabel(opt)}}</span>
                    <span class="px-1 py-2 selection rounded d-block" v-if="options.length<1&&searchValue!=''">Tidak ada yang relevan ditemukan.</span>
                    <!-- <span class="px-1 py-2 selection rounded d-block" v-if="options.length<1&&searchValue==''">Masukan kata kunci yang anda mau cari</span> -->
                </div>
                <!-- <div class="w-100 mt-1 border border-light rounded" style="overflow-y:scroll;top:0;max-height:250px"  v-if="options.length<1&&searchValue==''">
                    <span class="px-1 py-2 rounded d-block">Masukan kata kunci yang anda mau cari</span>
                </div> -->
            </div>
        </div>
    </div>
</template>
<style scoped>
.selection:hover{
    background:#2301e68c;
    color:white;
}
.btn {
    padding: 0px 3px;
}
.btn-exit{
    font-size: 10px;
    color:red;
    font-weight: bold;
}
</style>
<script>
import * as axios from 'axios'
export default {
    props:{
        smartKey:{
            type:String,
             default:''  
        },
        direct:{
            type:Boolean,
            default:false
        },
        searchValue:{
          type:String,
          default:''  
        },
        name:{
            type:String,
            default:''
        },
        usedefault:{
            type:Boolean,
            default:false
        },
        defaultValue:{
            type:String,
            default:''
        },
        init:{
            type:Boolean,
            default:false
        },
        placeholder:{
            Type:String,
            default:'Masukan value'
        },
        url:String,
        keyTag:String,
        labelTag:{
            type:Array,
            default:function(){
                return [];
            }
        },
        addon:{
            type:Object,
            default:function(){
                return new Object();
            }
        },
        customvalue:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            inputValue:'',
            hasValue:false,
            selected:'Klik untuk mencari data',
            isFocus:false,
            options:[],
            fetching:false,
            nextQueue:false,
        }
    },
    mounted(){
        // this.inputValue = this.searchValue
            console.log('hi there')
            this.isFocus=false
            if(this.init){
                this.valueChanged()
                console.log("smartsearch mounted")
            }
    },
    computed:{
        getLabelText(){
            if(this.customvalue!=''){
                return this.customvalue
            }
            if(this.usedefault&&this.defaultValue!=''){
                return this.defaultValue
            }
            if(this.selected!=''){
                return this.selected
            }
            return 'Klik untuk mencari'
        }
    },
    methods:{
        toggleActive(){
            
            !this.direct?this.isFocus=!this.isFocus:''
            
        },
        getLabel(value){
            // //console.clear()
            console.log('getting data')
            console.log(value)
            let currentObj=value;
            let tempObj = null;
            let tempValue='';
            if(this.labelTag.length>0){
                
                console.log(currentObj)
                console.log(this.labelTag)
                for(let x=0 ; x < this.labelTag.length ;x++){
                    if(tempValue!=''){
                        tempValue+=' '
                    }
                    tempObj=currentObj
                        var labels = this.labelTag[x].split(".");
                        for(let y=0; y < labels.length ;y++){
                            tempObj=tempObj[labels[y]];
                        }
                        tempValue+=tempObj
                }
                return tempValue;
            }else{
                return value[this.keyTag];
            }
        },
        clear(){
            // //console.clear()
            console.log('clearing')
            this.selected='Klik untuk mencari data'
            this.hasValue=false
            if(this.defaultValue!=''){
                this.usedefault=true
            }
            this.$emit('clear',true)
        },
        optHasKey(val1){
            return val1.toLowerCase().includes(this.searchValue.toLowerCase())
        },
        dataUpdate(data){
            //this.selected=data;
            this.inputValue = this.getLabel(data)
            if(this.direct){
                //this.searchValue=this.getLabel(data);
                console.log('selected smart search: '+ this.getLabel(data))
                this.$emit('update-direct',this.getLabel(data));
            }
            this.selected=this.getLabel(data);
            this.isFocus=!this.isFocus;
            this.hasValue=true
            this.$emit('update',data);
            this.usedefault=false
        },
        checkQueue(){
            if(this.fetching && !this.nextQueue){
                this.nextQueue=true;
                setTimeout(() => {
                    this.nextQueue=false;
                    this.valueChanged()
                }, 600);
                return;
            }else if(this.fetching && this.nextQueue){
                return;
            }
        },
        valueChanged(){
            //console.log('value changed')
            if(this.searchValue==''){
                this.options=[]
                this.isFocus=false
                console.log('reseting data')
                
                if(!this.init){
                    return;
                }
            }else{
                this.isFocus=true
            }
        
            console.log('fetching')
            this.checkQueue();
            this.fetching=true
            this.addon[this.keyTag]=this.searchValue;
            axios.post(this.$baseUrl+this.url,this.addon,{
                'headers':
                    {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
            }).then((result)=>{
                this.fetching=false 
                console.log('result')
                if(result.status==200){
                    this.options = result.data;
                    this.$forceUpdate()
                }else{
                    this.options = [];
                }
                this.$forceUpdate()
                console.log(this.options)
            }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                this.fetching=false
                console.log(err)
            })
        }
    }
}
</script>